import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selected',
})
export class SelectedPipe implements PipeTransform {
  transform(id: number, selectedIds: number[]): boolean {
    if (!id || !selectedIds || selectedIds.length === 0) {
      return false;
    }
    return selectedIds.some(value => id === value);
  }
}
